export default "__VITE_ASSET__DtLBvgzH__"